import { useTranslation } from "@flare/i18n";
import { cn } from "@flare/ui";

import { Text } from "@/components/v2/Text/Text";

export function PrivacyDisclaimer({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <div className={cn("mb-20 mt-3 md:mb-8", className)}>
      <Text variant="text-6" className="text-center">
        {t("FUNNEL_PRIVACY_DISCLAIMER_FIRST_LINE")}
      </Text>
      <Text variant="text-6" className="pb-2.5 text-center md:pb-0">
        {t("FUNNEL_PRIVACY_DISCLAIMER_SECOND_LINE")}
      </Text>
    </div>
  );
}
